import { useEffect, useState } from "react";

/** Compact (card) below this; table/desktop at 912px+ mockups. */
export const DATA_LAYOUT_DESKTOP_MIN_PX = 900;

export function useWideDataLayout() {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia(`(min-width: ${DATA_LAYOUT_DESKTOP_MIN_PX}px)`).matches
      : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(
      `(min-width: ${DATA_LAYOUT_DESKTOP_MIN_PX}px)`,
    );
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return matches;
}
